import { gaGetClientIdSync } from "utils/analytics"
import { ServiceType } from "utils/helpers"
import { BookingResult, BookingStatus, ErrorResponse } from "utils/interfaces"
import { Currency } from "modules/Booking/common/interfaces"
import { CURRENCY } from "utils/constants"
import { BookingDetails } from "modules/BookingCommon/common/interfaces"
import { waitForFieldUpdate } from "modules/BookingCommon/common/waitForFieldUpdate"
import * as utils from "utils/utils"
import { getTildaUtm } from "utils/utm"
import { UserAccount } from "utils/UserAccount"
import { httpClient } from "utils/infrastructure/httpClient"
import { getYmClientId } from "utils/analytics/yandex-metrika"

export function getBookingDetails(bookingHash: string) {
    const body = {
        booking_hash: bookingHash,
        client_name: UserAccount.name,
        client_email: UserAccount.email,
        ga_client_id: gaGetClientIdSync(),
        utm: getTildaUtm(),
    }
    return httpClient.post<BookingDetails & ErrorResponse>("booking-details", body).then((data) => {
        if (data.error) throw new Error(data.error)
        return data
    })
}

export function waitBookingStatusUpdate(
    bookingHash: string,
    currentStatus: BookingStatus
): Promise<BookingDetails> {
    return waitForFieldUpdate({
        errorText:
            "Статус бронирования не изменился за 2 минуты. Попробуйте обновить страницу или свяжитесь с поддержкой",
        isEqual: (last, current) => last.status === current.status,
        current: { status: currentStatus },
        promiseFactory: () => getBookingDetails(bookingHash),
    })
}

interface ClientData {
    id: number
    phone: string
    email: string
    name: string
}

interface BookSessionApiArgs {
    sessionDatetime: Date
    created_by_psychologist: boolean
    previous_client_data: Record<string, string>
    client_data: ClientData
    slot_id: string
    psy_hash_id: string
    service_type: ServiceType
    fix_session_time: boolean
}

export function bookSession({ sessionDatetime, ...data }: Partial<BookSessionApiArgs>) {
    const clientData = data.created_by_psychologist
        ? {}
        : {
              ga_client_id: gaGetClientIdSync(),
              ym_client_id: getYmClientId(),
              utm: getTildaUtm(),
          }
    const url = data.created_by_psychologist ? "book-session-psychologist" : "book-session-client"

    return httpClient.post<BookingResult & ErrorResponse>(url, {
        ...data,
        date: sessionDatetime && utils.formatUtcDateIso(sessionDatetime),
        time: sessionDatetime && utils.formatUtcTimeIso(sessionDatetime),
        ...clientData,
    })
}

export function putOrderAutoPay(order_id: string | number, external_id: string) {
    return httpClient.put<{
        payment_id: string
    }>(`payment/order/${order_id}/autopay`, {
        payment_tool_external_id: external_id,
        ga_client_id: gaGetClientIdSync(),
        utm: getTildaUtm(),
    })
}

export function updateCurrency(orderHash: string, currency: CURRENCY) {
    return httpClient.post<Currency & ErrorResponse>("order/currency", {
        order_hash: orderHash,
        currency: currency,
    })
}
